const state = {
  tableData: [
    { player_1: 0, player_2: 0, player_3: 0, player_4: 0 }
  ],
  columns: [
    { name: 'player_1', required: true, label: 'A', align: 'center', field: 'player_1', uid: '' },
    { name: 'player_2', required: true, label: 'B', align: 'center', field: 'player_2', uid: '' },
    { name: 'player_3', required: true, label: 'C', align: 'center', field: 'player_3', uid: '' },
    { name: 'player_4', required: true, label: 'D', align: 'center', field: 'player_4', uid: '' }
  ],
  currentPageNum: 1,
  loading: true,
  isSanma: false,
  unsubscribeF: ''
}
const mutations = {
  changeLastRow (state, payload) {
    state.tableData[state.tableData.length - 1][payload.player] = payload.val
  },
  changeCell (state, payload) {
    state.tableData[payload.targetIndex][payload.player] = payload.val
  },
  incrementLastRowCell (state, payload) {
    state.tableData[state.tableData.length - 1][payload.player]++
  },
  decrementLastRowCell (state, payload) {
    state.tableData[state.tableData.length - 1][payload.player]--
  },
  changeCurrentPageNum (state, val) {
    state.currentPageNum = val
  },
  incrementCurrentPageNum (state, payload) {
    state.currentPageNum++
  },
  changeLoading (state, val) {
    state.loading = val
  },
  setTableData (state, val) {
    state.tableData = val
  },
  setColumnLabel (state, payload) {
    state.columns[payload.num].label = payload.val
  },
  setColumnUID (state, payload) {
    state.columns[payload.num].uid = payload.val
  },
  addScoreRow (state) {
    let tmp = {}
    for (let key in state.columns) {
      tmp[state.columns[key].name] = 0
    }
    state.tableData.push(tmp)
  },
  changeIsSanma (state, val) {
    state.isSanma = val
  },
  toSanma (state, val) {
    state.columns = [
      { name: 'player_1', required: true, label: 'A', align: 'center', field: 'player_1', uid: '' },
      { name: 'player_2', required: true, label: 'B', align: 'center', field: 'player_2', uid: '' },
      { name: 'player_3', required: true, label: 'C', align: 'center', field: 'player_3', uid: '' }
    ]
    state.tableData = [ { player_1: 0, player_2: 0, player_3: 0 } ]
  },
  toYonma (state, val) {
    state.columns = [
      { name: 'player_1', required: true, label: 'A', align: 'center', field: 'player_1', uid: '' },
      { name: 'player_2', required: true, label: 'B', align: 'center', field: 'player_2', uid: '' },
      { name: 'player_3', required: true, label: 'C', align: 'center', field: 'player_3', uid: '' },
      { name: 'player_4', required: true, label: 'D', align: 'center', field: 'player_4', uid: '' }
    ]
    state.tableData = [ { player_1: 0, player_2: 0, player_3: 0, player_4: 0 } ]
  },
  setUnsubscribeF (state, val) {
    state.unsubscribeF = val
  }
}
const actions = {
  async setDataFromScoreID ({ dispatch, commit, state, rootState }, scoreID) {
    const doc = await rootState.db.collection('Scores').doc(scoreID).get()
    if (doc.exists) {
      if (Object.keys(doc.data().member).length === 3) {
        commit('changeIsSanma', true)
        commit('toSanma')
      } else {
        commit('changeIsSanma', false)
        commit('toYonma')
      }
      commit('setTableData', doc.data().score)
      let cnt = 0
      for (let key in doc.data().member) {
        if (key === '__index') {
          continue
        }
        commit('setColumnLabel', {num: cnt, val: doc.data().member[key].name})
        commit('setColumnUID', {num: cnt, val: doc.data().member[key].uid})
        ++cnt
      }
    }
    // for real time update
    dispatch('listenDataFromScoreDB', scoreID)
  },
  // for real time update
  listenDataFromScoreDB ({ commit, state, rootState }, scoreID) {
    const unsub = rootState.db.collection('Scores').doc(scoreID)
      .onSnapshot((doc) => {
        commit('setTableData', doc.data().score)
        let cnt = 0
        for (let key in doc.data().member) {
          if (key === '__index') {
            continue
          }
          commit('setColumnLabel', {num: cnt, val: doc.data().member[key].name})
          commit('setColumnUID', {num: cnt, val: doc.data().member[key].uid})
          ++cnt
        }
      })
    // for stop listen
    commit('setUnsubscribeF', unsub)
  },
  unsubscribeListenData ({ commit, state, rootState }) {
    state.unsubscribeF()
  },
  reset ({ commit, state, rootState }) {
    const initTableMember = ['A', 'B', 'C', 'D']
    let key = 0
    for (key in state.columns) {
      commit('setColumnLabel', {num: key, val: initTableMember[key]})
      commit('setColumnUID', {num: key, val: ''})
    }
    let tableData = [{}]
    if (state.columns.length === 4) {
      tableData = [{player_1: 0, player_2: 0, player_3: 0, player_4: 0}]
    } else {
      tableData = [{player_1: 0, player_2: 0, player_3: 0}]
    }
    commit('setTableData', tableData)
  },
  async makeNewScoreDB ({ commit, state, rootState }, payload) {
    const docRef = await rootState.db.collection('Scores').add({
      score: payload.tableData,
      timestamp: payload.timestamp
    })
    return docRef.id
  },
  async setScoreMemberToUserDB ({ commit, state, rootState }, payload) {
    const columns = state.columns
    let member = {}
    for (let key in columns) {
      member[columns[key].name] = {name: columns[key].label}
    }
    rootState.db.collection('Users').doc(payload.uid).collection('ScoreHistory').doc(payload.scoreID).set({
      scoreID: payload.scoreID,
      member: member,
      timestamp: payload.timestamp
    })
  },
  async setScoreIDToUserDB ({ commit, state, rootState }, payload) {
    rootState.db.collection('Users').doc(payload.uid).collection('ScoreHistory').doc(payload.scoreID).set({
      scoreID: payload.scoreID,
      timestamp: payload.timestamp
    }, { merge: true })
  },
  updateScoreMemberOfUserDB ({ commit, state, rootState }, payload) {
    const columns = state.columns
    let member = {}
    for (let key in columns) {
      member[columns[key].name] = {name: columns[key].label}
    }
    rootState.db.collection('Users').doc(payload.uid).collection('ScoreHistory').doc(payload.scoreID).update({
      member: member,
      timestamp: payload.timestamp
    })
  },
  async updateDBScoreMember ({ commit, state, rootState }, payload) {
    const columns = state.columns
    let member = {}
    for (let key in columns) {
      member[columns[key].name] = {name: columns[key].label, uid: columns[key].uid}
    }
    rootState.db.collection('Scores').doc(payload.scoreID).update({
      member: member
    })
  },
  updateScoreDB ({ commit, state, rootState }, payload) {
    // use my score id after first time
    rootState.db.collection('Scores').doc(payload.scoreID).update({
      score: payload.tableData,
      timestamp: payload.timestamp
    })
  }
}
const getters = {
  getTableData (state, getters, rootState) {
    return state.tableData
  },
  getColumns (state, getters, rootState) {
    return state.columns
  },
  getLastRow (state, getters, rootState) {
    return state.tableData[state.tableData.length - 1]
  },
  getLastRowPlayerVal: (state) => (player) => {
    return state.tableData[state.tableData.length - 1][player]
  },
  getCurrentPageNum (state, getters, rootState) {
    return state.currentPageNum
  },
  getLoading (state, getters, rootState) {
    return state.loading
  },
  getIsSanma (state, getters, rootState) {
    return state.isSanma
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ScoreTable.js